import { SettingsProviderDumb } from 'features/Settings/infra/react/Settings.state.react'
import { settingsStore } from 'features/Settings/infra/react/Settings.state.zustand.production'
import { ReactNode } from 'react'

export const SettingsProvider = ({ children }: { children?: ReactNode }) => (
  <SettingsProviderDumb store={settingsStore}>
    {children}
  </SettingsProviderDumb>
)
